import {gql} from "apollo-boost";

export const InstitutionsQuery = gql`
    query Institutions {
        institutions {
            institutionId
            scheduleId
            name
        }
    }
`;